import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { AiReadFile } from 'src/app/aplication/api/Manipulate/Ai';
import { Message, User } from 'src/app/aplication/api/Manipulate/Chat';
import { FileUploadDto } from 'src/app/aplication/api/Manipulate/File';
import { UserDto } from 'src/app/aplication/api/Manipulate/UserDto';
import { ChatService } from 'src/app/aplication/api/Services/ChatService';
import { UserService } from 'src/app/aplication/api/Services/User.service';

@Component({
  selector: 'app-chat-ai-lummy',
  templateUrl: './chat-ai-lummy.component.html',
  styleUrl: './chat-ai-lummy.component.scss'
})
export class ChatAiLummyComponent {
  public openedChat: boolean = false;

  private _infoPath !: AiReadFile;
  public get infoPath() : AiReadFile {
    return this._infoPath;
  }
  @Input() public set infoPath(v : AiReadFile) {
    this._infoPath = v;
    this.openedChat = false;
    //console.log( 'o filepath é ' +  this.infoPath.folderPath);

  }
  message!: Message;
  private _tema : string = 'light';
  public get tema() : string {
      return this._tema;
  }
  public set tema(v : string) {
      this._tema = v;
  }
  chatMode:number = 1;
  public myUser!:UserDto;

  constructor(
    protected _userService:UserService
  ) {
  }
  ngOnInit(): void {
    this._userService.GetUser().subscribe(
      event=>{
        this.myUser = event

    });
      this.setarTemaChat();

      //console.log( 'o filename é ' +  this.infoPath.fileName);
  }
  setarTemaChat(){
      var temaStorage = localStorage.getItem('KatiaColor');
      if(temaStorage){
          this.tema = temaStorage;
      }
  }
  OpenAi(mode:number){
      this.openedChat = true;
      this.chatMode=mode;
  }
}
